import { AuxButton, AuxTooltip } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { language } from "language/default";
import "./insSettingsTimePeriod.scss";
const TimePeriodTooltip = () => React.createElement(AuxTooltip, null,
    React.createElement(AuxButton, { icon: "info-bold", size: AuxButtonSizeEnum.XSMALL, slot: "target", type: AuxButtonTypeEnum.TERTIARY_SUBTLE, className: "insSettingsTooltipIcon" }),
    React.createElement("div", { slot: "content" },
        React.createElement("div", { className: "insTooltipContentWrapper" },
            React.createElement("div", { className: "insTooltipTitle" }, language.en.dashboard.timePeriod.timePeriod),
            React.createElement("div", null, language.en.dashboard.timePeriod.timePeriodTooltip))));
export const InsTimePeriodHeader = ({ title, subtitle }) => {
    if (!title && !subtitle) {
        return null;
    }
    return (React.createElement("div", { className: "header" },
        title && React.createElement("div", { className: "insRadioGroupDiv bottom-margin" },
            React.createElement("span", { className: "insSettingsLabel" }, title),
            React.createElement(TimePeriodTooltip, null)),
        subtitle && React.createElement("span", { className: "insSettingsSubLabel" }, subtitle)));
};
